export const initialState = {
  Section: {}
};
